import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { getSearchButtonText } from './helpers';

export interface ISearchButtonProps {
  count?: number | null;
  loading?: boolean;
  onClick?(event: React.MouseEvent): void;
}

export const SearchButton: React.FC<ISearchButtonProps> = ({ count, loading, onClick }) => {
  return (
    <Button loading={loading} onClick={onClick} size="XS" type="submit" data-testid="SearchButton">
      {getSearchButtonText(count)}
    </Button>
  );
};
